import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import ExpandItem from './ExpandItem';
import Item from './Item';
import LogoutItem from './LogoutItem';
import Box from '../../components/layout/Box';

import './styles.css';

const MenuContent = ({
  isMobile,
  handleClose,
  handleToggleOpen,
  isOpen: leftNavbarOpen,
}) => {
  const cognitoUser = useSelector((state) => state.auth.cognitoUser);

  const isOpen = leftNavbarOpen || isMobile;

  const navigate = useNavigate();

  function navigateToHome() {
    navigate('/');
  }

  function navigateToProfile() {
    navigate('/profile');
  }

  function navigateToNew() {
    navigate('/new?mode=search');
  }

  return (
    <Box className="flex-column flex-grow-1 justify-content-between">
      <Box className="flex-column">
        <Item
          icon="home-outline"
          title={<FormattedMessage defaultMessage="Startsida" />}
          isOpen={isOpen}
          onClick={navigateToHome}
        />

        {cognitoUser && (
          <Item
            icon="person-outline"
            title={<FormattedMessage defaultMessage="Min profil" />}
            isOpen={isOpen}
            onClick={navigateToProfile}
          />
        )}

        <Item
          icon="plus-outline"
          title={<FormattedMessage defaultMessage="Sälj kurslitteratur" />}
          isOpen={isOpen}
          onClick={navigateToNew}
        />
      </Box>

      <Box className="flex-column">
        <LogoutItem isOpen={isOpen} />

        {!isMobile && (
          <ExpandItem
            isOpen={leftNavbarOpen}
            handleToggleOpen={handleToggleOpen}
          />
        )}
      </Box>
    </Box>
  );
};

MenuContent.defaultProps = {
  isMobile: false,
};

export default MenuContent;
